<div *ngIf="isLoading">
    <div
        style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
    </div>
    <div *ngIf="percentage">
        <mat-spinner class="spinner-center" style="z-index: 1000;" aria-label="Rating">
        </mat-spinner>
        <div class="spinner-center" style="z-index: 1000; font-size: x-large;">{{ percentage | number : '1.0-1' }} %
        </div>
    </div>
    <mat-spinner *ngIf="!percentage" class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div mat-dialog-title>
    {{ modalData.title }}
    <div style="float: right; margin-top: -5px;">
        <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
            <img src="../../../../assets/close-white.png" style="width: 12px;">
        </button>
    </div>
</div>

<mat-dialog-content class="mat-typography">
    <div class="form-group row mt-1">
        <label class="col-3 col-form-label">ประเภทคำถาม<lifedi-require></lifedi-require></label>
        <div class="col-9">
            <select class="custom-select form-control" style="display: inline;" (change)="setType($event)"
                [(ngModel)]="type">
                <option selected disabled hidden>เลือกประเภท</option>
                <option *ngFor="let t of questionType" [value]="t.value">{{ t.name }}</option>
            </select>
        </div>
    </div>

    <div *ngIf="type" class="form-group row mt-1">
        <label class="col-3 col-form-label">คำถามสำหรับ<lifedi-require></lifedi-require></label>
        <div class="col-9">
            <select class="custom-select form-control" style="display: inline;" (change)="changeQuestion(questionIndex)"
                [(ngModel)]="questionIndex">
                <option selected disabled hidden>คำถามสำหรับ</option>
                <option *ngFor="let q of tag" [value]="q.value" [disabled]="!InformantForm.valid">{{ q.label ===
                    'Traget' ? 'Target' : q.label }}</option>
            </select>
        </div>
    </div>

    <form *ngIf="type" [formGroup]="InformantForm">
        <div *ngIf="type === 'multi_choice'" class="mb-2">
            <lifedi-questionInf-multiple-choice [informantForm]="InformantForm" [questionIndex]="questionIndex"
                (sendArr)="setInformantArr($event)" [isEditValue]="modalData.isEdit" (media)="getChoicesMedia($event)"
                (qMedia)="getQuestionMedia($event)" (qMediaType)="getQuestionMediaType($event)">
            </lifedi-questionInf-multiple-choice>
        </div>

        <div *ngIf="type === 'most/least'" class="mb-2">
            <lifedi-questionInf-most-least [informantForm]="InformantForm" [questionIndex]="questionIndex"
                (sendArr)="setInformantArr($event)" (qMedia)="getQuestionMedia($event)"
                (qMediaType)="getQuestionMediaType($event)"
                [isEditValue]="modalData.isEdit"></lifedi-questionInf-most-least>
        </div>

        <div *ngIf="type === 'ranking'" class="mb-2">
            <lifedi-questionInf-ranking [informantForm]="InformantForm" [questionIndex]="questionIndex"
                (sendArr)="setInformantArr($event)" [isEditValue]="modalData.isEdit"></lifedi-questionInf-ranking>
        </div>

        <div *ngIf="type === 'rating'" class="mb-2">
            <lifedi-questionInf-rating [informantForm]="InformantForm" [questionIndex]="questionIndex"
                (sendArr)="setInformantArr($event)" [isEditValue]="modalData.isEdit"></lifedi-questionInf-rating>
        </div>

        <!-- <div *ngIf="type === 'multi'" class="mb-2">
            <lifedi-question-multi [form]="informantFormArray['controls'][i]" [isEditValue]="modalData.isEdit">
            </lifedi-question-multi>
        </div> -->
    </form>


</mat-dialog-content>

<mat-dialog-actions *ngIf="InformantForm && !modalData.isEdit" align="center">
    <button *ngIf="InformantForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
        (click)="addQuestionList(InformantForm)">
        {{ modalData.actionBtnText }}
    </button>
    <button *ngIf="!InformantForm.valid" mat-button disabled="true">
        {{ modalData.actionBtnText }}
    </button>
</mat-dialog-actions>

<mat-dialog-actions *ngIf="InformantForm && modalData.isEdit" align="center">
    <button *ngIf="InformantForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
        (click)="editQuestionList(InformantForm)">
        {{ modalData.actionBtnText }}
    </button>
    <button *ngIf="!InformantForm.valid" mat-button disabled="true">
        {{ modalData.actionBtnText }}
    </button>
</mat-dialog-actions>